module.exports=function(){
    try {
        return require('react-web-component-style-loader/exports').styleElements;
    } catch(a) {
        return[];
    }
};
